export default "__VITE_ASSET__d7b700a3__"